/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	// 审批单据状态
	flowOrderStateDic: [
		{name: '草稿', value: -1, color: 'gray'},
		{name: '审批中', value: 1, color: 'blue'},
		{name: '已通过', value: 2, color: 'green'},
		{name: '已驳回', value: 3, color: 'red'},
		{name: '已撤销', value: 4, color: 'gray'}
	],

	// 服务类型
	serviceTypeDic: [
		{name: '售前服务', value: 1, color: '#00A1E9'},
		{name: '售后服务', value: 2, color: '#00486B'}
	],

	// 售后类型
	afterSaleTypeDic: [
		{name: '正常售后', value: 1 ,color: 'blue'},
		{name: '质量问题售后', value: 2 ,color: 'red'}
	],

	// 售后申请单状态
	orderTransferStatusDic: [
		{name: '待转单', value: 0, color: 'orange'},
		{name: '已转单', value: 1, color: 'green'}
	],
	
	// 申请单服务进度
	serviceProgressDic: [
		{name: '创建工单', value: 1},
		{name: '指派工单', value: 2},
		{name: '执行工单', value: 3},
		{name: '工单完结', value: 4},
		{name: '客户验收', value: 5}
	],

	// 工单状态
	afterSaleOrderStateDic: [
		{name: '草稿', value: 0, color: 'gray'},
		{name: '待派单', value: 1, color: 'red'},
		{name: '待确认', value: 6, color: 'orange'},
		{name: '待服务', value: 2, color: 'blue'},
		{name: '服务中', value: 3, color: 'blue'},
		{name: '待验收', value: 4, color: 'blue'},
		{name: '已完工', value: 5, color: 'green'},
		{name: '已关闭', value: 10, color: 'gray'}
	],

	// 我的售后工单状态
	mineAfterSaleOrderStateDic: [
		{name: '待确认', value: 6, color: 'orange'},
		{name: '待服务', value: 2, color: 'blue'},
		{name: '服务中', value: 3, color: 'blue'},
		{name: '待验收', value: 4, color: 'blue'},
		{name: '已完工', value: 5, color: 'green'}
	],

	// 工单紧急程度
	orderUrgencyDic: [
		{name: '普通', value: 1, color: 'gray'},
		{name: '重要', value: 2, color: 'yellow'},
		{name: '加急', value: 3, color: 'red', icon: '\ue657'}
	],

	//是否使用机台
	useMachineDic: [
		{name: '使用', value: 1, color: 'green'},
		{name: '不使用', value: 0, color: 'gray'}
	],

	//出行方式
	travelModeDic: [
		{name: '开公司车', value: 1, color: 'green'},
		{name: '公共交通', value: 2, color: 'orange'},
		{name: '其它', value: 3, color: 'gray'}
	],

	//招工类型
	recruitTypeDic: [
		{name: '临时', value: 1, color: 'blue'},
		{name: '长期', value: 2, color: 'green'},
		{name: '项目制', value: 3, color: 'orange'},
		{name: '其他', value: 4, color: 'red'}
	],

	// 报销类型
	reimbursementTypeDic: [
		{name: '工单费用报销', value: 1, color: 'blue'},
		{name: '日常费用报销', value: 2, color: 'blue'}
	],

	// 报销项类型
	expenseItemTypeDic: [
		{name: '公共费用', value: 1, color: 'blue'},
		{name: '个人费用', value: 2, color: 'orange'},
		{name: '一般费用', value: 3, color: 'green'}
	],

	// 请假类型
	leaveTypeDic: [
		{name: '事假', value: 1, color: 'blue', leave_granularity: 1},
		{name: '病假', value: 2, color: 'orange', leave_granularity: 1},
		{name: '年假', value: 3, color: 'green', leave_granularity: 1, showBalance: true},
		{name: '婚假', value: 4, color: 'purple', leave_granularity: 1},
		{name: '产假', value: 5, color: 'pink', leave_granularity: 1},
		{name: '丧假', value: 6, color: 'gray', leave_granularity: 1},
		{name: '其他', value: 7, color: 'default', leave_granularity: 1},
		{name: '育儿假', value: 8, color: 'green', leave_granularity: 1, showBalance: true},
		{name: '调休', value: 9, color: 'green', leave_granularity: 1}
	],
	
	// 请假时段
	timePeriodDic: [
		{name: '上午', value: 1, color: 'blue'},
		{name: '下午', value: 2, color: 'blue'}
	],
	
	// 加班类型
	overtimeTypeDic: [
		{name: '工单加班', value: 1, color: 'blue'},
		{name: '普通加班', value: 2, color: 'gray'}
	],
	
	// 加班日期类型
	overtimeDayTypeDic: [
		{name: '工作日加班', value: 0},
		{name: '节日加班', value: 1},
		{name: '工作日加班', value: 2},
		{name: '休息日加班', value: 3},
		{name: '休息日加班', value: 4},
		{name: '休息日加班', value: 9}
	],

	// 评价状态
	evaluateTypeDic: [
		{name: '待评价', value: 0, color: 'orange'},
		{name: '已评价', value: 1, color: 'green'}
	],

	//工单是否逾期
	isDelayedDic: [
		{name: '未逾期', value: 0, color: 'gray'},
		{name: '已逾期', value: 1, color: 'red'}
	],

	// 打卡方式
	signTypeOptions: [
		{name: '出发打卡', value: 1},
		{name: '到达打卡', value: 2},
		{name: '上班打卡', value: 3},
		{name: '下班打卡', value: 4},
		{name: '回网点打卡', value: 5}
	],

	// 维修类型
	repairTypeDic: [
		{name: '出现故障现象', value: 1, color: 'blue'},
		{name: '维修更换部件', value: 2, color: 'blue'},
	],

	// 维修状态
	repairStatusDic: [
		{name: '维修中', value: 1, color: 'red'},
		{name: '已完成', value: 2, color: 'green'}
	],

	// 工程师星级
	starLevelDic: [
		{
			name: '1星',
			value: 1,
		},
		{
			name: '2星',
			value: 2,
		},
		{
			name: '3星',
			value: 3,
		},
	],

}